import Swiper, { Navigation } from 'swiper';
import 'swiper/css'

class Slider {
    constructor(el) {
        this.el = el
        this.create()
    }

    create() {
        const swiper = new Swiper(this.el, {
            slidesPerView: 1.1,
            spaceBetween: 30,
            slideClass: "slider__item",
            modules: [Navigation],
            navigation: {
                nextEl: ".section-projects .swiper-button-next",
                prevEl: ".section-projects .swiper-button-prev",
            }, 
            breakpoints : {
                911 : {
                    slidesPerView : 3
                }
            }
        });
    }

    static bind() {
        const sliders = document.querySelectorAll('.section-projects .slider')
        sliders.forEach(slider => new Slider(slider))
    }

}

Slider.bind()